import { render, staticRenderFns } from "./template-list-dialog.vue?vue&type=template&id=15740c76"
import script from "./template-list-dialog.vue?vue&type=script&lang=js"
export * from "./template-list-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports